// IndexedDB 存储工具

const DB_NAME = 'MirrorXDB';
const DB_VERSION = 1;
const STORE_NAME = 'github';

// 初始化数据库
async function initDB() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);

    request.onupgradeneeded = (event) => {
      const db = event.target.result;
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME);
      }
    };

    request.onsuccess = (event) => {
      resolve(event.target.result);
    };

    request.onerror = (event) => {
      reject('IndexedDB 初始化失败');
    };
  });
}

// 存储 GitHub Token
export async function saveGitHubToken(token) {
  try {
    const db = await initDB();
    return new Promise((resolve, reject) => {
      const transaction = db.transaction([STORE_NAME], 'readwrite');
      const store = transaction.objectStore(STORE_NAME);
      const request = store.put(token, 'github_token');

      request.onsuccess = () => {
        resolve(true);
      };

      request.onerror = () => {
        reject('存储 Token 失败');
      };
    });
  } catch (error) {
    console.error('保存 GitHub Token 失败:', error);
    throw error;
  }
}

// 获取 GitHub Token
export async function getGitHubToken() {
  try {
    const db = await initDB();
    return new Promise((resolve, reject) => {
      const transaction = db.transaction([STORE_NAME], 'readonly');
      const store = transaction.objectStore(STORE_NAME);
      const request = store.get('github_token');

      request.onsuccess = (event) => {
        resolve(event.target.result || null);
      };

      request.onerror = () => {
        reject('获取 Token 失败');
      };
    });
  } catch (error) {
    console.error('获取 GitHub Token 失败:', error);
    return null;
  }
}

// 删除 GitHub Token
export async function removeGitHubToken() {
  try {
    const db = await initDB();
    return new Promise((resolve, reject) => {
      const transaction = db.transaction([STORE_NAME], 'readwrite');
      const store = transaction.objectStore(STORE_NAME);
      const request = store.delete('github_token');

      request.onsuccess = () => {
        resolve(true);
      };

      request.onerror = () => {
        reject('删除 Token 失败');
      };
    });
  } catch (error) {
    console.error('删除 GitHub Token 失败:', error);
    throw error;
  }
}
